
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const List = styled.ul`
  && {
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;

export const ListItem = styled.li`
&& {
    ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    return css`
      font-size: ${rem(14)};
      line-height: ${rem(22)};
      ${smallUp && `
        font-size: ${rem(16)};
        line-height: ${rem(24)};
      `};

      ${xlargeUp && `
        font-size: ${rem(20)};
        line-height: ${rem(30)};
      `};

      a {
        color: ${theme.colors.neutral.white};
      }
      a:hover {
        color: ${theme.colors.neutral.white};
        text-decoration: underline;
      }
      svg {
        color: ${theme.colors.cta.yellow};
        float: right;
        transform: rotate(270deg);
        margin-top: ${rem(8)};
      }
      padding: ${rem(16)} 0;
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.colors.lightBlue2};
      }
    `;
  }}
  }
`;
